import React from "react";
import "../components/Sign in/Signin.css";
const Problem = () => {
  return (
    <div
      className=""
      style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
    >
      <p className="alert fail">something went wrong please try again</p>
    </div>
  );
};

export default Problem;
